import { render, staticRenderFns } from "./ElCheckbox.vue?vue&type=template&id=b88b8ec6&"
import script from "./ElCheckbox.vue?vue&type=script&lang=js&"
export * from "./ElCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports